/** Validation/access rejections allow correction; ambiguous failures keep the same retry key. */
export function alphaMutationRejected(error:unknown){
 const status=error instanceof Error&&'statusCode' in error?error.statusCode:undefined;
 return typeof status==='number'&&[400,401,403,404,409,412,422,423].includes(status);
}
